"use strict";

var COLS, FIRST, KIFU_KOMA_LENGTH, KIFU_ROW_LENGTH, KIFU_ROW_LENGTH_SUB, MAX_VALUE, MIN_VALUE, ROWS, SECOND, Status;

Status = {
  OMOTE: 0,
  URA: 1,
  MOTIGOMA: 2
};

FIRST = -1;

SECOND = 1;

COLS = 3;

ROWS = 3;

MAX_VALUE = 50000;

MIN_VALUE = -50000;

KIFU_ROW_LENGTH = 9;

KIFU_ROW_LENGTH_SUB = 8;

KIFU_KOMA_LENGTH = 3;

module.exports = {
  Status: Status,
  FIRST: FIRST,
  SECOND: SECOND,
  COLS: COLS,
  ROWS: ROWS,
  MAX_VALUE: MAX_VALUE,
  MIN_VALUE: MIN_VALUE,
  KIFU_ROW_LENGTH: KIFU_ROW_LENGTH,
  KIFU_ROW_LENGTH_SUB: KIFU_ROW_LENGTH_SUB,
  KIFU_KOMA_LENGTH: KIFU_KOMA_LENGTH
};


//////////////////
// WEBPACK FOOTER
// ./const.coffee
// module id = 49
// module chunks = 0